import originalFetch from 'isomorphic-fetch'
import qs from 'qs';
import _ from 'underscore';
import { goLogin } from './util';

export const getAuth = () => {
  // return '9de65cdc44dc39a4dbf79049cf19d3608dc90c02ab0f32de7a268a7eae69fe348b3d299333eb125c291ad8b35d3b6d9873c5511f0da41e769c0ad47bca78375f973a9fbfb29bc548dddcec3c9c6027195456f563e278bd36f463e3d43b4828da';
  return localStorage.getItem('authHeader');
}

export function fetch(url, query = {}, config = {}) {
  function genQueryUrl(url, query) {
    const queryString = [];
    Object.keys(query).forEach(key => {
      if (query[key] !== undefined && query[key] !== null) {
        queryString.push(`${key}=${query[key]}`);
      }
    });

    return queryString.length ? `${url}?${queryString.join('&')}` : url;
  }

  // with cookie&content-type
  _.defaults(config, {
    credentials: 'include',
    headers: {},
    method: 'GET'
  });
  // 带authHeader
  const authHeader = getAuth();
  if (authHeader) {
    config.headers.AUTH = authHeader;
  }
  if (config.method === 'GET') {
    url = genQueryUrl(url, query)
  } else if (config.method === 'POST') {
    if (!(config.body instanceof FormData)) {
      if (!config.headers['Content-Type'] || config.headers['Content-Type'] === 'application/json') {
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(query)
      } else {
        config.body = qs.stringify(query)
      }
    }
    // if (query) {
    //   if() {
    //   }else{
    //   }
    // }
  } else {
    return false;
  }
  return originalFetch(url, config).then(
    res => {
      if (res.ok) {
        return res.json().then(json => {
          if (json.code === 60105) {
            //兑换码已经使用了哟～
            return Promise.resolve(json);
          }
          if ([401, 403].includes(json.code) ) {
            //账户cookie 验证权限失败的时候 跳转登录
            goLogin();
            return Promise.reject({code: 403});
          }
          // if (json.code === 400) {
          //   //兑换码不存在
          //   return Promise.resolve(json);
          // }
          if (json.code === 200) {
            return Promise.resolve(json);
          } else {
            return Promise.reject(json);
          }
        });
      } else if (res.status === 403) {
        goLogin();
        return Promise.reject({code: 403});
      }
      return res.json().then(Promise.reject.bind(Promise));
    }
  ).catch((err) => {
    return Promise.reject(err);
  });
}
